<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <label for="title">{{ $t("projectemailtemplate.title") }}</label>
            </div>
          </div>
          <div class="box-body" style="margin: 3rem">
            <label for="name" style="margin-bottom: 5rem">{{
              $t("projectemailtemplate.intro")
            }}</label>
            <!-- choose form -->
            <div class="contain_info">
              <div>{{ $t("mail_form_list.title") }}</div>
              <div style="width:75%">
                <select
                  @change="handleChooseForm()"
                  class="form-control"
                  v-model="keyTemplate"
                >
                  <option
                    v-for="item in template_emails"
                    v-bind:value="item.id"
                    :key="item.id"
                    >{{ item.name }}</option
                  >
                </select>
              </div>
            </div>
            <!-- snackbar -->
            <lte-core-alert
              v-for="snackbar in GET_SNACK_BAR"
              :key="snackbar.id"
              :item="snackbar"
            ></lte-core-alert>
            <!-- /.modal-dialog -->
          </div>
        </div>
      </row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// import utils from '@/lib/utils'

export default {
  name: "EmailTemplate",
  data() {
    return {
      template_emails: [],
      keyTemplate: null
    };
  },
  watch: {
    GET_PROJECT_EMAIL_TEMPLATE_DATA: function() {
      this.template_emails = [];
      this.GET_PROJECT_EMAIL_TEMPLATE_DATA.forEach(item => {
        let data = {
          id: item.id,
          name: item.name
        };
        this.template_emails.push(data);
      });
    },
    GET_PROJECT_TEMPLATE_USED_DATA: function() {
      let data = this.GET_PROJECT_TEMPLATE_USED_DATA;
      this.keyTemplate = data.invoice_template;
    }
  },
  computed: {
    ...mapGetters([
      "GET_PROJECT_EMAIL_TEMPLATE_DATA",
      "GET_SNACK_BAR",
      "GET_PROJECT_TEMPLATE_USED_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "GET_PROJECT_TEMPLATE",
      "UPDATE_PROJECT_EMAIL_TEMPLATE",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_PROJECT_TEMPLATE_USED"
    ]),
    handleChooseForm: function() {
      this.UPDATE_PROJECT_EMAIL_TEMPLATE({ id: this.keyTemplate }).then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    }
  },
  mounted() {
    this.GET_PROJECT_TEMPLATE();
    this.GET_PROJECT_TEMPLATE_USED();
  },
  components: {
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<style>
.contain_info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4%;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/ProjectEmailTemplate.vue